import {
	AppBar,
	Dialog,
	Menu,
	MenuItem,
	Slide,
	Toolbar,
	Typography,
	WithStyles,
} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import * as Actions from '../actions/imstat';
import ReactTable, {
	RowInfo,
	RowRenderProps,
} from '../components/MyReactTable';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import Config from '../site.config.json';
import { CMItemCode, isValid } from '../utils/CMData';
import { getSystemMst, MasterItemCode } from '../utils/MasterData';
import { Routes, Screens } from '../utils/Routes';
import CertificationFileUpload from './CertificationFileUpload';
const ITEM_HEIGHT = 48;

const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
			width: 'auto',
		},
		dialog: {
			width: '55%',
		},
		link: {
			color: 'blue',
			cursor: 'pointer',
		},
		pointer: {
			cursor: 'pointer',
		},
		rowBlue: {
			'&:hover': {
				backgroundColor: '#CEDDFF !important',
			},
			backgroundColor: '#D9E5Ff !important',
		},
		rowGray: {
			'&:hover': {
				backgroundColor: '#E5E5E5 !important',
			},
			backgroundColor: '#EEEEEE !important',
		},
		rowOrange: {
			'&:hover': {
				backgroundColor: '#FFEFBC !important',
			},
			backgroundColor: '#FFF4D1 !important',
		},
		rowPink: {
			'&:hover': {
				backgroundColor: '#FFD6DA !important',
			},
			backgroundColor: '#FFE1E4 !important',
		},
		scrollPaper: {
			alignItems: 'flex-start',
		},
	});

interface IState {
	appChangeOkFlg?: boolean;
	appCancelOkFlg?: boolean;
	lecCancelOkFlg?: boolean;
	appResultOkFlg?: boolean;
	enqueteDispFlg?: boolean;
	taskReportOkFlg?: boolean;
	appLectureOkFlg?: boolean;
	retakeOkFlg?: boolean;
	referenceOkFlg?: boolean;
	certificateDispFlg?: boolean;
	certificateUploadFlg?: boolean;
	assessMentResultDispFlg?: boolean;
	careerTypeID?: string;
	selectColumnsMenuAnchorEl?: HTMLElement;
	functionMenuAnchorEl?: HTMLElement;
	certificationUploadDialog: boolean;
	careerID: string;
	classID: string;
	dialogOpen: boolean;
	dialogMessage: string;
	reasonCode: string;
	seq: string;
	contentFlg?: string;
}

/**
 * カリキュラム一覧テーブル
 */
class CurriculumContentTable extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			careerID: '',
			certificationUploadDialog: false,
			classID: '',
			dialogMessage: '',
			dialogOpen: false,
			reasonCode: '',
			seq: '',
		};

		this.showDetail = this.showDetail.bind(this);
		this.showChangeApplication = this.showChangeApplication.bind(this);
		this.showCancelApplication = this.showCancelApplication.bind(this);
		this.showActResultApplication = this.showActResultApplication.bind(
			this
		);
		this.showStCancel = this.showStCancel.bind(this);
		this.showExercise = this.showExercise.bind(this);
		this.showQuestionnaire = this.showQuestionnaire.bind(this);
		this.showApply = this.showApply.bind(this);
		this.showApplicationStatus = this.showApplicationStatus.bind(this);
		this.showActResultReference = this.showActResultReference.bind(this);
		this.showComplCertificate = this.showComplCertificate.bind(this);
		this.showHistory = this.showHistory.bind(this);
		this.handleCloseDialog = this.handleCloseDialog.bind(this);
		this.handleOpenAssessmentResult = this.handleOpenAssessmentResult.bind(
			this
		);
		this.handCertificationUpload = this.handCertificationUpload.bind(this);
	}

	public render() {
		const { classes } = this.props;
		const { functionMenuAnchorEl } = this.state;
		const columns = this.getSelectedColumns();

		return (
			<div>
				<ReactTable
					data={this.props.data}
					columns={columns}
					defaultPageSize={5}
					className="-striped -highlight"
					getTrProps={this.setRowColor(classes)}
					sortable={false}
					columnsMenu={true}
					menuHandler={this.handleSelectColumns}
				/>
				{this.getSelectColumnsMenu()}
				<Menu
					anchorEl={functionMenuAnchorEl}
					open={Boolean(functionMenuAnchorEl)}
					onClose={this.handleCloseMenu}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
					transformOrigin={{ vertical: 'top', horizontal: 'center' }}
					getContentAnchorEl={undefined}
					PaperProps={{
						style: {
							maxHeight: ITEM_HEIGHT * 4.5,
							width: 300,
						},
					}}
				>
					<MenuItem onClick={this.showDetail}>
						{i18n.t('CurriculumContentTable_0001')}
					</MenuItem>
					{this.state.appChangeOkFlg && (
						<MenuItem onClick={this.showChangeApplication}>
							{i18n.t('CurriculumContentTable_0002')}
						</MenuItem>
					)}
					{this.state.appCancelOkFlg && (
						<MenuItem onClick={this.showCancelApplication}>
							{i18n.t('CurriculumContentTable_0003')}
						</MenuItem>
					)}
					{this.state.appResultOkFlg && (
						<MenuItem onClick={this.showActResultApplication}>
							{i18n.t('CurriculumContentTable_0004')}
						</MenuItem>
					)}
					{this.state.lecCancelOkFlg && (
						<MenuItem onClick={this.showStCancel}>
							{this.state.careerTypeID === '10'
								? i18n.t('CurriculumContentTable_0005')
								: i18n.t('CurriculumContentTable_0006')}
						</MenuItem>
					)}
					{this.state.taskReportOkFlg && (
						<MenuItem onClick={this.showExercise}>
							{i18n.t('CurriculumContentTable_0007')}
						</MenuItem>
					)}
					{this.state.enqueteDispFlg && (
						<MenuItem onClick={this.showQuestionnaire}>
							{i18n.t('CurriculumContentTable_0008')}
						</MenuItem>
					)}
					{this.state.appLectureOkFlg && (
						<MenuItem onClick={this.showApply}>
							{this.state.careerTypeID === '10'
								? i18n.t('CurriculumContentTable_0009')
								: i18n.t('CurriculumContentTable_0010')}
						</MenuItem>
					)}
					{this.state.retakeOkFlg && (
						<MenuItem onClick={this.showApply}>
							{i18n.t('CurriculumContentTable_0011')}
						</MenuItem>
					)}
					{this.state.referenceOkFlg && (
						<MenuItem onClick={this.showActResultReference}>
							{i18n.t('CurriculumContentTable_0012')}
						</MenuItem>
					)}
					{this.state.certificateUploadFlg && (
						<MenuItem onClick={this.handCertificationUpload}>
							{i18n.t('CurriculumContentTable_0013')}
						</MenuItem>
					)}
					{this.state.certificateDispFlg && (
						<MenuItem onClick={this.showComplCertificate}>
							{this.state.careerTypeID === '10'
								? i18n.t('CurriculumContentTable_0014')
								: i18n.t('CurriculumContentTable_0015')}
						</MenuItem>
					)}
					{this.state.assessMentResultDispFlg && (
						<MenuItem onClick={this.handleOpenAssessmentResult}>
							{i18n.t('CurriculumContentTable_0016')}
						</MenuItem>
					)}
					{this.state.careerTypeID === '1' &&
						this.state.contentFlg === '1' && (
							<MenuItem onClick={this.showHistory}>
								{i18n.t('CurriculumContentTable_0017')}
							</MenuItem>
						)}
				</Menu>
				<Dialog
					fullScreen={false}
					TransitionComponent={Transition}
					open={this.state.certificationUploadDialog}
					onClose={this.handleCloseDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: classes.dialog,
					}}
				>
					<AppBar className={classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handleCloseDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18n.t('CurriculumContentTable_0018')}
							</Typography>
						</Toolbar>
					</AppBar>
					<CertificationFileUpload
						careerID={this.state.careerID}
						classID={this.state.classID}
						seq={this.state.seq}
						reasonCode={this.state.reasonCode}
					/>
				</Dialog>
			</div>
		);
	}

	/**
	 * 詳細画面表示
	 * @param e イベントオブジェクト
	 */
	protected showDetail(e: React.MouseEvent<HTMLElement>) {
		if (this.state.functionMenuAnchorEl) {
			const index = this.state.functionMenuAnchorEl.getAttribute(
				'data-index'
			);
			if (!index) {
				return;
			}
			const rowData: Actions.ICurriculmContent = this.props.data[index];
			const { careerID, careerTypeID } = rowData;
			if (careerTypeID === '10') {
				let to = Routes.getPath(Screens.PERSONAL_SKILL_DETAIL);
				to = to.replace(/\/:skill_id/, `/${rowData.careerID}`);
				this.props.pushHistory(to);
			} else {
				let to = Routes.getPath(Screens.PERSONAL_CAREER_DETAIL);
				to = to.replace(/\/:career_id/, `/${careerID}`);
				this.props.pushHistory(to);
			}
		}
		this.setState({ functionMenuAnchorEl: undefined });
	}

	/**
	 * 認定証アップロード
	 * @param rowResult
	 */
	protected handCertificationUpload(e: React.MouseEvent<HTMLElement>) {
		if (this.state.functionMenuAnchorEl) {
			const index = this.state.functionMenuAnchorEl.getAttribute(
				'data-index'
			);
			if (index && index !== '') {
				const rowData: Actions.ICurriculmContent = this.props.data[
					index
				];
				const { careerID, classID, reasonCode, seq } = rowData;
				this.setState({
					careerID,
					certificationUploadDialog: true,
					classID,
					functionMenuAnchorEl: undefined,
					reasonCode,
					seq,
				});
			}
		}
	}

	/**
	 * アセスメント回答結果表示
	 * @param rowResult
	 */
	protected handleOpenAssessmentResult(e: React.MouseEvent<HTMLElement>) {
		if (this.state.functionMenuAnchorEl) {
			const index = this.state.functionMenuAnchorEl.getAttribute(
				'data-index'
			);
			if (index && index !== '') {
				const rowData: Actions.ICurriculmContent = this.props.data[
					index
				];
				const { careerID, classID, rankID } = rowData;
				let to = Routes.getPath(Screens.PERSONAL_ASSESSMENT_RESULT);
				to = to.replace(/\/:career_id\//, `/${careerID}/`);
				to = to.replace(/\/:class_id\//, `/${classID}/`);
				to = to.replace(/\/:rank_id/, `/${rankID}`);
				this.props.pushHistory(to);
			}
		}
	}

	protected handleCloseDialog = () => {
		this.setState({
			careerID: '',
			certificationUploadDialog: false,
			classID: '',
		});
	};

	/**
	 * 申請変更画面表示
	 * @param e イベントオブジェクト
	 */
	protected showChangeApplication(e: React.MouseEvent<HTMLElement>) {
		if (this.state.functionMenuAnchorEl) {
			const index = this.state.functionMenuAnchorEl.getAttribute(
				'data-index'
			);
			if (index && index !== '') {
				const rowData: Actions.ICurriculmContent = this.props.data[
					index
				];
				const { careerID, classID, careerTypeID } = rowData;

				let to = Routes.getPath(Screens.PERSONAL_APPLICATION_CHANGE);
				to = to.replace(/\/:career_id/, `/${careerID}`);
				to = to.replace(/\/:career_typeid/, `/${careerTypeID}`);
				to = to.replace(/\/:class_id/, `/${classID}`);
				this.props.pushHistoryState(to, {
					caller: window.location.pathname,
					skillViewFlg: careerTypeID === '10',
				});
			}
		}
		this.setState({ functionMenuAnchorEl: undefined });
	}

	/**
	 * 申請取消画面表示
	 * @param e イベントオブジェクト
	 */
	protected showCancelApplication(e: React.MouseEvent<HTMLElement>) {
		if (this.state.functionMenuAnchorEl) {
			const index = this.state.functionMenuAnchorEl.getAttribute(
				'data-index'
			);
			if (index && index !== '') {
				const rowData: Actions.ICurriculmContent = this.props.data[
					index
				];
				const { aplType, careerID, classID, careerTypeID } = rowData;

				let to = Routes.getPath(Screens.PERSONAL_APPLICATION_CANCEL);
				to = to.replace(/\/:career_id/, `/${careerID}`);
				to = to.replace(/\/:class_id/, `/${classID}`);
				to = to.replace(/\/:apl_type/, `/${aplType}`);
				this.props.pushHistoryState(to, {
					caller: window.location.pathname,
					skillViewFlg: careerTypeID === '10',
				});
			}
		}
		this.setState({ functionMenuAnchorEl: undefined });
	}

	/**
	 * 実績申請画面表示
	 * @param e イベントオブジェクト
	 */
	protected showActResultApplication(e: React.MouseEvent<HTMLElement>) {
		if (this.state.functionMenuAnchorEl) {
			const index = this.state.functionMenuAnchorEl.getAttribute(
				'data-index'
			);
			if (index && index !== '') {
				const rowData: Actions.ICurriculmContent = this.props.data[
					index
				];
				const { careerID, classID, careerTypeID } = rowData;
				if (careerTypeID === '10' && this.state.appLectureOkFlg) {
					const to = Routes.getPath(
						Screens.PERSONAL_LECTURE_APPLICATION
					);
					this.props.pushHistoryState(to, {
						caller: window.location.pathname,
						careerType: '10',
						resultApply: true,
						targetCareerId: careerID,
					});
				} else {
					let to = Routes.getPath(
						Screens.PERSONAL_ACT_RESULT_APPLICATION
					);
					to = to.replace(/\/:career_id/, `/${careerID}`);
					to = to.replace(/\/:class_id/, `/${classID}`);
					to = to.replace(/\/:nittei_only_flg/, `/0`);
					this.props.pushHistoryState(to, {
						caller: window.location.pathname,
						skillViewFlg: careerTypeID === '10',
					});
				}
			}
		}
		this.setState({ functionMenuAnchorEl: undefined });
	}

	/**
	 * 受講取消画面表示
	 * @param e イベントオブジェクト
	 */
	protected showStCancel(e: React.MouseEvent<HTMLElement>) {
		if (this.state.functionMenuAnchorEl) {
			const index = this.state.functionMenuAnchorEl.getAttribute(
				'data-index'
			);
			if (index && index !== '') {
				const rowData: Actions.ICurriculmContent = this.props.data[
					index
				];
				const { careerID, classID, careerTypeID } = rowData;
				let to = Routes.getPath(Screens.PERSONAL_LECTURE_CANCEL);
				to = to.replace(/\/:career_id/, `/${careerID}`);
				to = to.replace(/\/:class_id/, `/${classID}`);
				to = to.replace(/\/:curriculum_flg/, `/0`);
				this.props.pushHistoryState(to, {
					caller: window.location.pathname,
					skillViewFlg: careerTypeID === '10',
				});
			}
		}
		this.setState({ functionMenuAnchorEl: undefined });
	}

	/**
	 * 受講申請画面表示（受講申請、再申請共通）
	 * @param e イベントオブジェクト
	 */
	protected showApply(e: React.MouseEvent<HTMLElement>) {
		if (this.state.functionMenuAnchorEl) {
			const index = this.state.functionMenuAnchorEl.getAttribute(
				'data-index'
			);
			if (index && index !== '') {
				const rowData: Actions.ICurriculmContent = this.props.data[
					index
				];
				const { careerID, careerTypeID } = rowData;
				const to = Routes.getPath(Screens.PERSONAL_LECTURE_APPLICATION);
				const state = {
					caller: window.location.pathname,
					careerType: careerTypeID,
					targetCareerId: careerID,
				};
				this.props.pushHistoryState(to, state);
			}
		}
		this.setState({ functionMenuAnchorEl: undefined });
	}

	/**
	 * 課題提出画面表示
	 * @param e イベントオブジェクト
	 */
	protected showExercise = (e: React.MouseEvent<HTMLElement>) => {
		if (!this.state.functionMenuAnchorEl) {
			return;
		}
		const index = this.state.functionMenuAnchorEl.getAttribute(
			'data-index'
		);
		if (!index) {
			return;
		}
		const rowData: Actions.ICurriculmContent = this.props.data[index];
		const { careerID, classID } = rowData;
		let to = Routes.getPath(Screens.PERSONAL_EXERCISE);
		to = to.replace(/\/:career_id\//, `/${careerID}/`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		this.props.pushHistoryState(to, {
			caller: window.location.pathname,
			outOfPeriodFlg: rowData.outOfPeriodFlg,
		});
	};

	/**
	 * アンケート回答画面表示
	 * @param e イベントオブジェクト
	 */
	protected showQuestionnaire = (e: React.MouseEvent<HTMLElement>) => {
		if (!this.state.functionMenuAnchorEl) {
			return;
		}
		const index = this.state.functionMenuAnchorEl.getAttribute(
			'data-index'
		);
		if (!index) {
			return;
		}
		const rowData: Actions.ICurriculmContent = this.props.data[index];
		const { careerID, classID, outOfPeriodFlg } = rowData;
		let pathname = Routes.getPath(Screens.PERSONAL_QUESTIONNAIRE);
		pathname = pathname.replace(/\/:career_id\//, `/${careerID}/`);
		pathname = pathname.replace(/\/:class_id$/, `/${classID}`);
		this.props.pushHistoryState(pathname, {
			caller: window.location.pathname,
			outOfPeriodFlg,
			showTree: true,
		});
	};

	/**
	 * テスト履歴画面表示
	 * @param e イベントオブジェクト
	 */
	protected showHistory(e: React.MouseEvent<HTMLElement>) {
		if (this.state.functionMenuAnchorEl) {
			const index = this.state.functionMenuAnchorEl.getAttribute(
				'data-index'
			);
			if (index && index !== '') {
				const rowData: Actions.ICurriculmContent = this.props.data[
					index
				];
				const { careerID, classID } = rowData;
				let to = Routes.getPath(
					Screens.PERSONAL_TEST_QUESTIONNAIRE_HISTORY
				);
				to = to.replace(/\/:career_id/, `/${careerID}`);
				to = to.replace(/\/:class_id/, `/${classID}`);
				this.props.pushHistory(to);
			}
		}
		this.setState({ functionMenuAnchorEl: undefined });
	}

	/**
	 * 申請内容画面表示
	 * @param e イベントオブジェクト
	 */
	protected showApplicationStatus(e: React.MouseEvent<HTMLElement>) {
		const index = e.currentTarget.getAttribute('data-index');
		if (index && index !== '') {
			const rowData: Actions.IOnGoingELearning = this.props.data[index];
			const { careerID, classID, aplType } = rowData;
			let to = Routes.getPath(Screens.PERSONAL_APPLICATION_STATUS);
			to = to.replace(/\/:career_id/, `/${careerID}`);
			to = to.replace(/\/:class_id/, `/${classID}`);
			to = to.replace(/\/:apl_type/, `/${aplType}`);
			to = to.replace(/\/:curriculum_flg/, `/0`);
			this.props.pushHistory(to);
		}
	}

	/**
	 * 実績参照画面表示
	 * @param e イベントオブジェクト
	 */
	protected showActResultReference = (e: React.MouseEvent<HTMLElement>) => {
		if (this.state.functionMenuAnchorEl) {
			const index = this.state.functionMenuAnchorEl.getAttribute(
				'data-index'
			);
			if (!index) {
				return;
			}

			const rowData: Actions.ICurriculmContent = this.props.data[index];
			const {
				careerID,
				classID,
				seq,
				reasonCode,
				statusNum,
				careerTypeID,
			} = rowData;
			let to = Routes.getPath(Screens.PERSONAL_ACT_RESULT_REFERENCE);
			to = to.replace(/\/:career_id/, `/${careerID}`);
			to = to.replace(/\/:class_id/, `/${classID}`);
			to = to.replace(/\/:seq/, `/${seq}`);

			const state = {
				careerID,
				classID,
				imstatListStatusId: statusNum,
				reasonCode,
				seq,
				skillViewFlg: careerTypeID === '10',
			};
			this.props.pushHistoryState(to, state);
		}
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 修了証明書表示
	 * @param e イベントオブジェクト
	 */
	protected showComplCertificate = (e: React.MouseEvent<HTMLElement>) => {
		if (this.state.functionMenuAnchorEl) {
			const index = this.state.functionMenuAnchorEl.getAttribute(
				'data-index'
			);
			if (!index) {
				return;
			}
			const rowData: Actions.IResultELearning = this.props.data[index];
			const {
				careerID,
				careerTypeID,
				classID,
				reasonCode,
				seq,
			} = rowData;
			const { userAttr } = this.props;
			if (careerTypeID === '10') {
				let url =
					Config.tsqPath +
					'/tsq/pkg/action/per/skillCertificate.action?';
				url = url + 'accessType=10';
				url = url + '&userId=' + userAttr.userId;
				url = url + '&careerID=' + careerID;
				url = url + '&classID=' + classID;
				url = url + '&reasonCode=' + reasonCode;
				url = url + '&seq=' + seq;
				window.open(url, '_blank');
			} else {
				let url =
					Config.tsqPath + '/tsq/pkg/action/per/certificate.action?';
				url = url + 'userId=' + userAttr.userId;
				url = url + '&locale=' + userAttr.locale;
				url = url + '&lang=' + userAttr.lang;
				url = url + '&careerID=' + careerID;
				url = url + '&accessType=10';
				window.open(url, '_blank');
			}
		}
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 行カラー設定
	 */
	protected setRowColor = (classes: Record<string, string>) => (
		state: any,
		rowInfo: RowInfo
	) => {
		if (rowInfo === undefined) {
			return {};
		}
		let className: string = '';
		if (rowInfo.original.compulsoryCssClass === 'row_color_pink') {
			className = classes.rowPink;
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_orange') {
			className = classes.rowOrange;
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_blue') {
			className = classes.rowBlue;
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_gray') {
			className = classes.rowGray;
		}

		return {
			className,
		};
	};

	/**
	 * 全列情報取得
	 */
	protected getAllColumns(): any[] {
		const cmFlg: boolean = isValid(CMItemCode.CM_ENABLED);
		return [
			{
				Cell: (row: RowRenderProps) => {
					return (
						<div>
							<IconButton
								aria-label="More"
								aria-owns={
									this.state.functionMenuAnchorEl
										? 'long-menu'
										: undefined
								}
								aria-haspopup="true"
								key={row.value}
								data-index={row.index}
								onClick={this.handleOpenMenu}
								size="small"
							>
								<MenuIcon />
							</IconButton>
						</div>
					);
				},
				accessor: 'sousa',
				required: true,
				sortable: false,
				width: 40,
			},
			{
				Cell: (row: RowRenderProps) =>
					i18n.t(row.value, { ns: 'force' }),
				Header: i18n.t('CurriculumContentTable_0019'),
				accessor: 'subCareerSetId',
				width: 80,
			},
			{
				Header: i18n.t('CurriculumContentTable_0033'),
				accessor: 'studyOrder',
				width: 80,
			},
			{
				Header: i18n.t('CurriculumContentTable_0020'),
				accessor: 'compulsoryID',
				width: 40,
			},
			{
				Header: cmFlg
					? i18n.t('CurriculumContentTable_0021')
					: i18n.t('CurriculumContentTable_0022'),
				accessor: 'careerTitle',
				width: 300,
			},
			{
				Cell: (row: RowRenderProps) => {
					const careerType = row.value;
					if (
						careerType === 'eラーニング' ||
						careerType === '集合研修' ||
						careerType === '通信教育' ||
						careerType === 'カリキュラム' ||
						careerType === '資格' ||
						careerType === '業務経験' ||
						careerType === 'スキル診断'
					) {
						return i18n.t(careerType, { ns: 'force' });
					} else {
						return careerType;
					}
				},
				Header: cmFlg
					? i18n.t('CurriculumContentTable_0023')
					: i18n.t('CurriculumContentTable_0024'),
				accessor: 'careerType',
				width: 100,
			},
			{
				Cell: (row: RowRenderProps) => {
					let jissiKikan = row.value;
					if (jissiKikan && jissiKikan.indexOf('～') !== -1) {
						jissiKikan = jissiKikan.replace(
							'～',
							i18n.t('～', {
								ns: 'force',
							})
						);
					}
					return jissiKikan;
				},
				Header: i18n.t('CurriculumContentTable_0025'),
				accessor: 'jissiKikan',
				width: 200,
			},
			{
				Header: i18n.t('CurriculumContentTable_0026'),
				accessor: 'classroom',
				width: 100,
			},
			{
				Header: i18n.t('CurriculumContentTable_0027'),
				accessor: 'cost',
				width: 100,
			},
			{
				Header: i18n.t('CurriculumContentTable_0028'),
				accessor: 'credit',
				width: 100,
			},
			{
				Header: i18n.t('CurriculumContentTable_0029'),
				accessor: 'target',
				width: 100,
			},
			{
				Header: i18n.t('CurriculumContentTable_0030'),
				accessor: 'organizer',
				width: 100,
			},
			{
				Header: i18n.t('CurriculumContentTable_0031'),
				accessor: 'comment',
				width: 100,
			},
			{
				Cell: (row: RowRenderProps) => {
					const status = i18n.t(row.value, { ns: 'force' });
					if (
						row.original.aplType ===
						('0' || '1' || '2' || '3' || '4')
					) {
						return (
							<span
								className={this.props.classes.link}
								onClick={this.showApplicationStatus}
								data-index={row.index}
							>
								{status}
							</span>
						);
					}
					return <div>{status}</div>;
				},
				Header: i18n.t('CurriculumContentTable_0032'),
				accessor: 'status',
			},
		];
	}

	/**
	 * 行スタイル設定
	 * @param state
	 * @param rowInfo 行情報
	 * @param columns
	 */
	protected setRowStyle(state: any, rowInfo: RowInfo, columns: undefined) {
		if (rowInfo === undefined) {
			return {
				style: {
					height: 62,
				},
			};
		}
		let rowColor: string = '';
		if (rowInfo.original.compulsoryCssClass === 'row_color_pink') {
			rowColor = '#FFE1E4';
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_orange') {
			rowColor = '#FFF4D1';
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_blue') {
			rowColor = '#D9E5Ff';
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_gray') {
			rowColor = '#EEEEEE';
		}
		return {
			backgroundColor: rowColor,
		};
	}

	/**
	 * 選択行取得
	 */
	protected getSelectedColumns() {
		let columns: any[] = Object.assign([], this.getAllColumns());

		columns.map((column: any) => {
			if (column.required) {
				column.show = true;
			} else {
				column.show = false;
			}
		});

		this.props.selectedColumns.map((index: number) => {
			columns[index].show = true;
		});

		const careerTypeControl = getSystemMst(
			MasterItemCode.CAREER_TYPE_CONTROL
		);
		if (careerTypeControl === '0') {
			columns = columns.filter((column: any) => {
				return column.accessor !== 'classroom';
			});
		}
		return columns;
	}

	/**
	 * 行選択メニュー取得
	 */
	protected getSelectColumnsMenu() {
		const { classes } = this.props;
		const allColumns = this.getAllColumns();
		const careerTypeControl = getSystemMst(
			MasterItemCode.CAREER_TYPE_CONTROL
		);
		let checkboxList: any[] = [];
		allColumns.map((column: any, index: number) => {
			if (!column.required) {
				checkboxList.push({
					accessor: column.accessor,
					checked: this.props.selectedColumns.indexOf(index) !== -1,
					index,
					text: column.Header,
				});
			}
		}, this);
		if (careerTypeControl === '0') {
			checkboxList = checkboxList.filter((column: any) => {
				return column.accessor !== 'classroom';
			});
		}
		return (
			<Menu
				id="logout-menu"
				anchorEl={this.state.selectColumnsMenuAnchorEl}
				open={this.state.selectColumnsMenuAnchorEl ? true : false}
				onClose={this.handleCloseSelectColumns}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				getContentAnchorEl={undefined}
			>
				{checkboxList.map((checkboxItem, i) => {
					return (
						<MenuItem key={i}>
							<Checkbox
								id={checkboxItem.text}
								onChange={this.handleChangeCheckBox(
									checkboxItem
								)}
								checked={checkboxItem.checked}
							/>
							<InputLabel
								className={classes.pointer}
								htmlFor={checkboxItem.text}
							>
								{checkboxItem.text}
							</InputLabel>
						</MenuItem>
					);
				})}
			</Menu>
		);
	}

	/**
	 * メニューオープンハンドラ
	 */
	protected handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
		const index = event.currentTarget.getAttribute('data-index');
		if (index && index !== '') {
			const rowData: Actions.ICurriculmContent = this.props.data[index];
			const {
				appChangeOkFlg,
				appCancelOkFlg,
				lecCancelOkFlg,
				appResultOkFlg,
				contentFlg,
				enqueteDispFlg,
				taskReportOkFlg,
				appLectureOkFlg,
				retakeOkFlg,
				referenceOkFlg,
				certificateDispFlg,
				certificateUploadFlg,
				assessMentResultDispFlg,
				careerTypeID,
			} = rowData;

			this.setState({
				appCancelOkFlg,
				appChangeOkFlg,
				appLectureOkFlg,
				appResultOkFlg,
				assessMentResultDispFlg,
				careerTypeID,
				certificateDispFlg,
				certificateUploadFlg,
				contentFlg,
				enqueteDispFlg,
				lecCancelOkFlg,
				referenceOkFlg,
				retakeOkFlg,
				taskReportOkFlg,
			});

			this.setState({ functionMenuAnchorEl: event.currentTarget });
		}
	};

	/**
	 * メニュークローズハンドラ
	 */
	protected handleCloseMenu = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 列選択ハンドラ
	 */
	protected handleSelectColumns = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({
			selectColumnsMenuAnchorEl: event.currentTarget,
		});
	};

	/**
	 * 列選択メニュークローズハンドラ
	 */
	protected handleCloseSelectColumns = () => {
		this.setState({
			selectColumnsMenuAnchorEl: undefined,
		});
	};

	/**
	 * チェック状態変更ハンドラ
	 */
	protected handleChangeCheckBox = (checkboxItem: any) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const newSelectedColumns = Object.assign(
			[],
			this.props.selectedColumns
		);
		const idx = newSelectedColumns.indexOf(checkboxItem.index);

		if (event.target.checked) {
			if (idx === -1) {
				newSelectedColumns.push(checkboxItem.index);
			}
		} else {
			if (idx !== -1) {
				newSelectedColumns.splice(idx, 1);
			}
		}
		this.props.setSelectedColumns(newSelectedColumns);
	};
}

const Transition: React.FC<any> = props => {
	return <Slide direction="up" {...props} />;
};

const mapStateToProps = (state: IRootState) => ({
	cmFlg: state.login.showCMOption,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	pushHistory: (path: string) => dispatch(push(path)),
	pushHistoryState: (path: string, state: any) =>
		dispatch(
			push({
				pathname: path,
				state,
			})
		),
	setSelectedColumns: (selectedColumns: number[]) =>
		dispatch(
			Actions.setCurriculmContentSelectedColumns({ selectedColumns })
		),
});

export interface ICurriculumContentTableProps {
	data: Actions.ICurriculmContent[];
	selectedColumns: number[];
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ICurriculumContentTableProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(CurriculumContentTable);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/CurriculumContentTable.tsx